import type { TransactionsReport } from 'model/TransactionsReport';
import type { Action } from 'redux';

// Action Types
export const TRANSACTIONS_REPORT_GET_START = 'TRANSACTIONS_REPORT_GET_START';
export const TRANSACTIONS_REPORT_GET_SUCCESS = 'TRANSACTIONS_REPORT_GET_SUCCESS';
export const TRANSACTIONS_REPORT_GET_ERROR = 'TRANSACTIONS_REPORT_GET_ERROR';

// Actions
export type TransactionsReportGetStartAction = Action<typeof TRANSACTIONS_REPORT_GET_START>;

export interface TransactionsReportGetSuccessAction extends Action<typeof TRANSACTIONS_REPORT_GET_SUCCESS> {
    payload: {
        report: TransactionsReport;
    };
}

export type TransactionsReportGetErrorAction = Action<typeof TRANSACTIONS_REPORT_GET_ERROR>;

export type TransactionsReportAction =
    | TransactionsReportGetStartAction
    | TransactionsReportGetSuccessAction
    | TransactionsReportGetErrorAction;
